import { render, staticRenderFns } from "./mandala-footer.component.vue?vue&type=template&id=3fe6edd3&scoped=true&"
import script from "./mandala-footer.component.vue?vue&type=script&lang=js&"
export * from "./mandala-footer.component.vue?vue&type=script&lang=js&"
import style0 from "./mandala-footer.component.vue?vue&type=style&index=0&id=3fe6edd3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe6edd3",
  null
  
)

export default component.exports